import { fg } from '@atlaskit/platform-feature-flags';

import { type EditionAwarenessContextType } from './edition-awareness-context';

export function isEligibleForStandardToPremium({
	product,
	edition,
	userRoles,
	trialOfferingName,
}: EditionAwarenessContextType): boolean {
	if (
		edition === 'standard' &&
		userRoles?.includes('SITE_ADMIN') &&
		trialOfferingName === 'premium'
	) {
		if (product === 'jira' && fg('edition_awareness_upsell_jira_fg')) {
			return true;
		}
		if (product === 'jira-service-management' && fg('edition_awareness_upsell_jsm_fg')) {
			return true;
		}
		if (product === 'confluence' && fg('edition_awareness_standard_upsell_confluence_ab_fg')) {
			return true;
		}
		if (product === 'jira-product-discovery' && fg('upsell_edition_awareness_jpd_fg')) {
			return true;
		}
	}

	return false;
}
